// Staging + bookkeeping for email attachments. Drive files are attached by the
// backend straight from Drive (fileId); local files are staged into Storage.
import { getStorage, ref, uploadBytes } from "firebase/storage";

export const ATTACHMENT_LIMIT_BYTES = 20 * 1024 * 1024; // Gmail-safe cap

export async function stageLocalFile(dealId, file) {
  const storage = getStorage();
  const path = `emailAttachments/${dealId}/${Date.now()}-${file.name}`;
  await uploadBytes(ref(storage, path), file);
  return { name: file.name, source: "storage", storagePath: path, size: file.size };
}

export function driveFileToAttachment(f) {
  return {
    name: f.name,
    source: "drive",
    fileId: f.id,
    size: Number(f.size) || 0,
  };
}

export function totalAttachmentSize(list) {
  return (list || []).reduce((sum, a) => sum + (Number(a.size) || 0), 0);
}
